<table [formGroup]="parentFormGroup">
  <thead>
    <tr>
      <th class="text-center" *ngIf="check || order"></th>
      <th class="text-center">Código</th>
      <th class="title">Projeto</th>
      <th class="">Previsão Término</th>
      <th class="" *ngIf="expand == true"></th>
    </tr>
  </thead>
  <tbody formArrayName="acProjects" cdkDropList [cdkDropListDisabled]="!order"
  (cdkDropListDropped)="order ? onOrderItem($event) : null">
    <ng-container *ngFor="let pro of acProjects?.controls; let i_p = index"  [formGroupName]="i_p">
      <tr class="container-tr"  *ngIf="currentItem[i_p] as variable"  cdkDrag  cdkDragLockAxis="y"
        [ngClass]="{'priority':variable.prt_est_id}" class="tr-{{i_p % 2}}">
        <td class="text-center" *ngIf="check">
          <input type="checkbox" class="ms-2" [checked]="variable?.checkeds" formControlName="checkeds" (change)="onCheckStatus()"/>
        </td>
        <td class="text-center" *ngIf="order">
          <div class="drag-handle">
            <img src="assets/images/svgs/menu.svg" alt="Mover" tooltip="Mover" placement="bottom">
          </div>
        </td>
        <td class="text-center">{{variable?.id}}{{variable?.prt_est_id? " P": ""}}</td>
        <td class="title">
          {{variable?.title}}
          <span *ngIf="variable?.prt_est_id">(prioritário - em monitoramento intensivo)</span>
          <span *ngIf="variable?.issue_type == '2'">{{variable?.son_name}}</span>
        </td>
        <td class="text-center">{{variable?.month_year}}</td>
        <td *ngIf="expand == true">
          <span class="icon-table icon-button" *ngIf="variable?.acPrtIssuesCommon?.length > 0" (click)="variable['show_PrtIssues'] = variable['show_PrtIssues'] != null? !variable['show_PrtIssues']:true">
            <img src="assets/images/svgs/lupa{{variable?.show_PrtIssues?'-menos':''}}.svg" alt="Consultar" tooltip="Consultar" placement="bottom">
          </span>
        </td>
      </tr>
      <tr *ngIf="currentItem[i_p]['acPrtIssuesCommon']?.length > 0 && currentItem[i_p]['show_PrtIssues'] == true" class="inner-tr">
        <td colspan="5">
          
          <app-itens-ac-prt-issues *ngIf="currentItem[i_p]['acPrtIssuesCommon'] as acPrtIssuesCommon"
            [formArray]="getFormArray(i_p)"
            [currentItem]="acPrtIssuesCommon" class="system-table" [parentId]="pro.get('id').value ">
          </app-itens-ac-prt-issues>
        </td>
      </tr>
    </ng-container>
  </tbody>
</table>